// extracted by mini-css-extract-plugin
export default {"container":"Paginado_container__11Hoy","previousPage":"Paginado_previousPage__dljDj","nextPage":"Paginado_nextPage__qTlK7","input":"Paginado_input__lbMtG","p":"Paginado_p__KcdVl"};